<app-data-table mainTitle="Plano de Contas Receita Federal"
            singleTitle="Conta Contábil"
            routerPath="/plano-contas-rfb"
            entityPath="/planocontasrfb"
            keyField="id"
            [entity]="planoContasRfb"
            [columns]="this['columns']"
            [controls]="this['controls']">
</app-data-table>